module.exports = __webpack_public_path__ + "img/14.170a59b7.jpg";